import type { AvatarFallbackComponentProps } from '@frameio/vapor';
import { theme } from '@frameio/vapor';

export const DefaultAvatar = ({
  height = 40,
  width = 40,
}: AvatarFallbackComponentProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 40 40"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0h40v40H0z" fill={theme.colors.background.primary} />
    <path
      d="M17.708 18.958h-3.333c-.69 0-1.25-.56-1.25-1.25v-3.333c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25zM25.624 18.958h-3.333c-.69 0-1.25-.56-1.25-1.25v-3.333c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25zM17.708 26.874h-3.333c-.69 0-1.25-.56-1.25-1.25v-3.333c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25zM25.624 26.874h-3.333c-.69 0-1.25-.56-1.25-1.25v-3.333c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25z"
      stroke={theme.colors.icon.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);
